// app.routing.ts
import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './auth.guard';
import { IndexSurchargesComponent } from './fees/surcharges/index-surcharges/index-surcharges.component';
import { FormSurchargesComponent } from './fees/surcharges/form-surcharges/form-surcharges.component';
import { IndexServiciosComponent } from './administration/services/index-servicios.component';
import { FormServiciosComponent } from './administration/services/form-servicios.component';
import { UsersListComponent } from './users/users-list.component';
import { UsersFormComponent } from './users/users-form.component';
import { RolesListComponent } from './roles/roles-list.component';
import { RolesFormComponent } from './roles/roles-form.component';
import { PlaidComponent } from './plaid/plaid.component';
import { DriverComponent } from './driver/driver.component';
import { FeesComponent } from './fees/fees.component';
import { StripeComponent } from './stripe/stripe.component';
import { DriverFormComponent } from './driver/driver-form.component';
import { CustomersListComponent } from './customers/customers-list.component';
import { CustomersFormComponent } from './customers/customers-form.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { ContactsListComponent } from './invoices/contacts/contacts-list/contacts-list.component';
import { ContactsFormComponent } from './invoices/contacts/contacts-form/contacts-form.component';
import { ItemsListComponent } from './invoices/items/items-list/items-list.component';
import { ItemsFormComponent } from './invoices/items/items-form/items-form.component';
import { InvoicesListComponent } from './invoices/invoices-list.component';
import { PaypalComponent } from './paypal/paypal.component';
import { AccountingComponent } from './accounting/accounting.component';
import { AccountingFormComponent } from './accounting/accounting-form/accounting-form.component';
import { ConfigsListComponent } from './configs/configs-list.component';
import { ConfigsFormComponent } from './configs/configs-form.component';
import { CourierChargesListComponent } from './fees/courierCharges/courier-charges-list/courier-charges-list.component';
import { CourierChargesFormComponent } from './fees/courierCharges/courier-charges-form/courier-charges-form.component';
import { TaskChargesListComponent } from './fees/taskCharges/task-charges-list/task-charges-list.component';
import { TaskChargesFormComponent } from './fees/taskCharges/task-charges-form/task-charges-form.component';
import { PersonnelListComponent } from './accounting/personnel/personnel-list/personnel-list.component';
import { PersonnelFormComponent } from './accounting/personnel/personnel-form/personnel-form.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DriverCourierListComponent } from './fees/driverFees/driver-courier-list/driver-courier-list.component';
import { DriverCourierFormComponent } from './fees/driverFees/driver-courier-form/driver-courier-form.component';
import { DriverTaskListComponent } from './fees/driverFees/driver-task-list/driver-task-list.component';
import { DriverTaskFormComponent } from './fees/driverFees/driver-task-form/driver-task-form.component';
import { RegisterComponent } from './pages/register/register.component';
import { HelcimComponent } from './helcim/helcim.component';
import { SquareComponent } from './square/square.component';
import { HumanPersonnelListComponent } from './human-resources/human-personnel/human-personnel-list/human-personnel-list.component';
import { HumanPersonnelFormComponent } from './human-resources/human-personnel/human-personnel-form/human-personnel-form.component';
import { VolumeChargesListComponent } from './fees/volumeCharges/volume-charges-list/volume-charges-list.component';
import { VolumeChargesFormComponent } from './fees/volumeCharges/volume-charges-form/volume-charges-form.component';
import { WeightChargesListComponent } from './fees/weightCharges/weight-charges-list/weight-charges-list.component';
import { WeightChargesFormComponent } from './fees/weightCharges/weight-charges-form/weight-charges-form.component';
import { DriverVolumeListComponent } from './fees/driverFees/driver-volume-list/driver-volume-list.component';
import { DriverVolumeFormComponent } from './fees/driverFees/driver-volume-form/driver-volume-form.component';
import { DriverWeightListComponent } from './fees/driverFees/driver-weight-list/driver-weight-list.component';
import { DriverWeightFormComponent } from './fees/driverFees/driver-weight-form/driver-weight-form.component';
import { MarketingListComponent } from './marketing/marketing-list/marketing-list.component';
import { VisitorComponent } from './pages/visitor/visitor.component';
import { ToolkitListComponent } from './human-resources/toolkit/toolkit-list/toolkit-list.component';
import { WpBotListComponent } from './hub/wpBot/wp-bot-list/wp-bot-list.component';
import { ChatBotListComponent } from './hub/chatBot/chat-bot-list/chat-bot-list.component';
import { WpBotFormComponent } from './hub/wpBot/wp-bot-form/wp-bot-form.component';
import { ChatBotFormComponent } from './hub/chatBot/chat-bot-form/chat-bot-form.component';
import { CompanyListComponent } from './company/company-list/company-list.component';
import { MerchantComponent } from './merchant/merchant.component';
import { AnalysisComponent } from './analysis/analysis.component';
import { DriverEmmListComponent } from './fees/driverFees/driver-emm-list/driver-emm-list.component';
import { DriverEmmFormComponent } from './fees/driverFees/driver-emm-form/driver-emm-form.component';
import { EmmChargesListComponent } from './fees/emmCharges/emm-charges-list/emm-charges-list.component';
import { EmmChargesFormComponent } from './fees/emmCharges/emm-charges-form/emm-charges-form.component';
import { AdsComponent } from './marketing/ads/ads.component';
import { QbExpenseListComponent } from './quickbooks/quickbooksExpense/qb-expense-list/qb-expense-list.component';
import { QbExpenseFormComponent } from './quickbooks/quickbooksExpense/qb-expense-form/qb-expense-form.component';
import { QbVendorListComponent } from './quickbooks/quickbooksVendors/qb-vendor-list/qb-vendor-list.component';
import { QbVendorFormComponent } from './quickbooks/quickbooksVendors/qb-vendor-form/qb-vendor-form.component';
import { DocsListComponent } from './docs/docs-list/docs-list.component';
import { DocsFormComponent } from './docs/docs-form/docs-form.component';
import { CategoriesListComponent } from './categories/categories-list.component';
import { CategoriesFormComponent } from './categories/categories-form.component';
import { SocialComponent } from './marketing/social/social.component';
import { MediaroomComponent } from './marketing/mediaroom/mediaroom.component';
import { ObsMarketingComponent } from './observability/obs-marketing/obs-marketing.component';
import { ObsAdsComponent } from './observability/obs-ads/obs-ads.component';
import { ObsSocialComponent } from './observability/obs-social/obs-social.component';
import { ObsSocialAuditComponent } from './observability/obs-social/audits/obs-social-audit.component';
import { ObsSocialExecutiveComponent } from './observability/obs-social/executive/obs-social-executive.component';
import { ObsSocialLeadsComponent } from './observability/obs-social/leads/obs-social-leads.component';
import { ObsMediaroomComponent } from './observability/obs-mediaroom/obs-mediaroom.component';
import { ObsLogisticsComponent } from './observability/obs-logistics/obs-logistics.component';
import { ObsAccountingComponent } from './observability/obs-accounting/obs-accounting.component';
import { ObsFinanceComponent } from './observability/obs-finance/obs-finance.component';
import { ObsHrComponent } from './observability/obs-hr/obs-hr.component';
import { SeoRegistryListComponent } from './marketing/seo/seo-registry/seo-registry-list/seo-registry-list.component';
import { SeoRegistryFormComponent } from './marketing/seo/seo-registry/seo-registry-form/seo-registry-form.component';
import { SeoMetricsDailyListComponent } from './marketing/seo/seoMetricsDaily/seo-metrics-daily-list/seo-metrics-daily-list.component';
import { SeoActionsBacklogListComponent } from './marketing/seo/seo-actions-backlog/seo-actions-backlog-list/seo-actions-backlog-list.component';
import { SeoMetricsWeeklyListComponent } from './marketing/seo/seo-metrics-weekly/seo-metrics-weekly-list/seo-metrics-weekly-list.component';
import { QaRunFormComponent } from './marketing/seo/qa-run/qa-run-form/qa-run-form.component';
import { QaRunListComponent } from './marketing/seo/qa-run/qa-run-list/qa-run-list.component';
import { InternalLinksListComponent } from './marketing/seo/internal-links/internal-links-list/internal-links-list.component';
import { SeoOffPageCampaignsListComponent } from './marketing/seo/seo-off-page-campaigns/seo-off-page-campaigns-list/seo-off-page-campaigns-list.component';
import { SeoOffPageCampaignsFormComponent } from './marketing/seo/seo-off-page-campaigns/seo-off-page-campaigns-form/seo-off-page-campaigns-form.component';
import { SeoOffPageCampaignsReviewsComponent } from './marketing/seo/seo-off-page-campaigns/seo-off-page-campaigns-reviews/seo-off-page-campaigns-reviews.component';
import { UrlMappingComponent } from './marketing/seo/seo-off-page-campaigns/url-mapping/url-mapping.component';
import { OnPageComponent } from './marketing/seo/on-page/on-page.component';
import { SeoOffPageRecommendationsListComponent } from './marketing/seo/seo-off-page-recommendations/seo-off-page-recommendations-list/seo-off-page-recommendations-list.component';
import { SeoOffPageRecommendationsFormComponent } from './marketing/seo/seo-off-page-recommendations/seo-off-page-recommendations-form/seo-off-page-recommendations-form.component';
import { SeoOffPageProspectsListComponent } from './marketing/seo/seo-off-page-prospects/seo-off-page-prospects-list/seo-off-page-prospects-list.component';
import { SeoOffPageProspectsFormComponent } from './marketing/seo/seo-off-page-prospects/seo-off-page-prospects-form/seo-off-page-prospects-form.component';
import { SeoOffPageBacklinksListComponent } from './marketing/seo/seo-off-page-backlinks/seo-off-page-backlinks-list/seo-off-page-backlinks-list.component';
import { SeoOffPageBacklinksFormComponent } from './marketing/seo/seo-off-page-backlinks/seo-off-page-backlinks-form/seo-off-page-backlinks-form.component';
import { SeoOffPageDashboardComponent } from './marketing/seo/seo-off-page-dashboard/seo-off-page-dashboard.component';
import { SeoCannibalClusterListComponent } from './observability/seo/seo-cannibal-cluster/seo-cannibal-cluster-list.component';
import { SeoCannibalClusterFormComponent } from './observability/seo/seo-cannibal-cluster/seo-cannibal-cluster-form.component';
import { SeoCannibalEdgeListComponent } from './observability/seo/seo-cannibal-edge/seo-cannibal-edge-list.component';
import { GbpLocationsListComponent } from './observability/seo/local-seo/locations/locations-page.component';
import { GbpReviewsInboxComponent } from './observability/seo/local-seo/reviews/reviews-inbox-page.component';
import { LocalActionsQueueComponent } from './observability/seo/local-seo/actions/actions-queue-page.component';
import { TechnicalAuditsPageComponent } from './observability/seo/technical-audits/technical-audits-page.component';
import { SitemapAuditsPageComponent } from './observability/seo/sitemap-audits/sitemap-audits-page.component';
import { MediaRoomRegistryListComponent } from './marketing/mediaroom/mediaroom-registry/mediaroom-registry-list/mediaroom-registry-list.component';
import { MediaRoomRegistryFormComponent } from './marketing/mediaroom/mediaroom-registry/mediaroom-registry-form/mediaroom-registry-form.component';
import { OffPagePerformanceListComponent } from './observability/seo/off-page-performance/off-page-performance-list.component';
import { OffPagePerformanceDetailComponent } from './observability/seo/off-page-performance/off-page-performance-detail.component';
import { SeoKeywordInsightListComponent } from './observability/seo/seo-keyword-insight/seo-keyword-insight-list.component';
import { SeoKeywordInsightDetailComponent } from './observability/seo/seo-keyword-insight/seo-keyword-insight-detail.component';
import { LogisticsListComponent } from './logistics/logistics-list.component';
import { SocialContentRequestListComponent } from './marketing/social/social-content-request/social-content-request-list/social-content-request-list.component';
import { SocialContentRequestFormComponent } from './marketing/social/social-content-request/social-content-request-form/social-content-request-form.component';
import { SocialRegistryListComponent } from './marketing/social/social-registry/social-registry-list/social-registry-list.component';
import { SocialRegistryFormComponent } from './marketing/social/social-registry/social-registry-form/social-registry-form.component';
import { InternalLinksComponent } from './marketing/seo/internal-links/internal-links/internal-links.component';
import { TechnicalQaComponent } from './marketing/seo/technical-qa/technical-qa.component';
import { LocalSeoComponent } from './marketing/seo/local-seo/local-seo.component';
import { OffPageComponent } from './marketing/seo/off-page/off-page.component';
import { PerformanceComponent } from './marketing/seo/performance/performance.component';
import { RegistryComponent } from './marketing/registry/registry/registry.component';
import { SemantikaComponent } from './marketing/social/semantika/semantika/semantika.component';
import { StrategyComponent } from './marketing/social/strategy/strategy/strategy.component';
import { PerformanceSocialComponent } from './marketing/social/performance-social/performance-social.component';
import { RequestIntakeComponent } from './marketing/social/request-intake/request-intake.component';
import { MroomsocialComponent } from './marketing/mediaroom/social/mroomsocial/mroomsocial.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'pages/login',
    pathMatch: 'full',
  },

  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'forms',
        loadChildren: () => import('./forms/forms.module').then((m) => m.Forms),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./tables/tables.module').then((m) => m.TablesModule),
      },
      {
        path: 'maps',
        loadChildren: () =>
          import('./maps/maps.module').then((m) => m.MapsModule),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./widgets/widgets.module').then((m) => m.WidgetsModule),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./charts/charts.module').then((m) => m.ChartsModule),
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./calendar/calendar.module').then((m) => m.CalendarModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./userpage/user.module').then((m) => m.UserModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./timeline/timeline.module').then((m) => m.TimelineModule),
      },
      /* {
        path: 'fees',
        component: FeesComponent,
      },
      {
        path: 'fees/courier',
        component: CourierChargesListComponent,
      }, */

      // {
      //   path: 'fees',
      //   children: [
      //     {
      //       path: '',
      //       component: CourierChargesListComponent,
      //     },
      //     {
      //       path: 'courier/add',
      //       component: CourierChargesFormComponent,
      //     },
      //     {
      //       path: 'courier/edit/:id',
      //       component: CourierChargesFormComponent,
      //     },
      //     {
      //       path: 'surcharges',
      //       component: IndexSurchargesComponent,
      //     },
      //     {
      //       path: 'surcharges/create',
      //       component: FormSurchargesComponent,
      //     },
      //     {
      //       path: 'surcharges/edit/:id',
      //       component: FormSurchargesComponent,
      //     },
      //     {
      //       path: 'task',
      //       component: TaskChargesListComponent,
      //     },
      //     {
      //       path: 'task/add',
      //       component: TaskChargesFormComponent,
      //     },
      //     {
      //       path: 'task/edit/:id',
      //       component: TaskChargesFormComponent,
      //     },
      //     {
      //       path: 'volume',
      //       component: VolumeChargesListComponent,
      //     },
      //     {
      //       path: 'volume/add',
      //       component: VolumeChargesFormComponent,
      //     },
      //     {
      //       path: 'volume/edit/:id',
      //       component: VolumeChargesFormComponent,
      //     },
      //     {
      //       path: 'weight',
      //       component: WeightChargesListComponent,
      //     },
      //     {
      //       path: 'weight/add',
      //       component: WeightChargesFormComponent,
      //     },
      //     {
      //       path: 'weight/edit/:id',
      //       component: WeightChargesFormComponent,
      //     },
      //     {
      //       path: 'driverCourier',
      //       component: DriverCourierListComponent,
      //     },
      //     {
      //       path: 'driverCourier/add',
      //       component: DriverCourierFormComponent,
      //     },
      //     {
      //       path: 'driverCourier/edit/:id',
      //       component: DriverCourierFormComponent,
      //     },
      //     {
      //       path: 'driverTask',
      //       component: DriverTaskListComponent,
      //     },
      //     {
      //       path: 'driverTask/add',
      //       component: DriverTaskFormComponent,
      //     },
      //     {
      //       path: 'driverTask/edit/:id',
      //       component: DriverTaskFormComponent,
      //     },
      //     {
      //       path: 'driverVolume',
      //       component: DriverVolumeListComponent,
      //     },
      //     {
      //       path: 'driverVolume/add',
      //       component: DriverVolumeFormComponent,
      //     },
      //     {
      //       path: 'driverVolume/edit/:id',
      //       component: DriverVolumeFormComponent,
      //     },
      //     {
      //       path: 'driverWeight',
      //       component: DriverWeightListComponent,
      //     },
      //     {
      //       path: 'driverWeight/add',
      //       component: DriverWeightFormComponent,
      //     },
      //     {
      //       path: 'driverWeight/edit/:id',
      //       component: DriverWeightFormComponent,
      //     },
      //     {
      //       path: 'emm',
      //       component: EmmChargesListComponent,
      //     },
      //     {
      //       path: 'emm/add',
      //       component: EmmChargesFormComponent,
      //     },
      //     {
      //       path: 'emm/edit/:id',
      //       component: EmmChargesFormComponent,
      //     },
      //     {
      //       path: 'driverEmm',
      //       component: DriverEmmListComponent,
      //     },
      //     {
      //       path: 'driverEmm/add',
      //       component: DriverEmmFormComponent,
      //     },
      //     {
      //       path: 'driverEmm/edit/:id',
      //       component: DriverEmmFormComponent,
      //     },
      //   ],
      // },
      {
        path: 'numbers',
        children: [
          {
            path: '',
            component: StripeComponent,
          },
          {
            path: 'finance/plaid',
            component: PlaidComponent,
          },

          {
            path: 'finance/paypal',
            component: PaypalComponent,
          },
          {
            path: 'finance/helcim',
            component: HelcimComponent,
          },
          {
            path: 'finance/square',
            component: SquareComponent,
          },
          {
            path: 'finance/merchant',
            component: MerchantComponent,
          },
          {
            path: 'finance/analysis',
            component: AnalysisComponent,
          },
          //accounting
          {
            path: 'accounting',
            component: PersonnelListComponent,
          },
          {
            path: 'accounting/external',
            component: AccountingComponent,
          },
          {
            path: 'accounting/external/add',
            component: AccountingFormComponent,
          },
          {
            path: 'accounting/external/edit/:id',
            component: AccountingFormComponent,
          },
          {
            path: 'accounting/personnel/add',
            component: PersonnelFormComponent,
          },
          {
            path: 'accounting/personnel/edit/:id',
            component: PersonnelFormComponent,
          },
          {
            path: 'accounting/freelancers',
            component: PersonnelListComponent,
          },
          {
            path: 'accounting/freelancers/edit/:id',
            component: PersonnelFormComponent,
          },
          {
            path: 'accounting/drivers',
            component: PersonnelListComponent,
          },
          {
            path: 'accounting/drivers/edit/:id',
            component: PersonnelFormComponent,
          },
          {
            path: 'accounting/customers',
            component: PersonnelListComponent,
          },
          {
            path: 'accounting/customers/edit/:id',
            component: PersonnelFormComponent,
          },
          {
            path: 'accounting/invoices',
            component: InvoicesListComponent,
          },
          {
            path: 'accounting/quickbooks/expenses',
            component: QbExpenseListComponent,
          },
          {
            path: 'accounting/quickbooks/expenses/add',
            component: QbExpenseFormComponent,
          },
          {
            path: 'accounting/quickbooks/expenses/edit/:id/:syncToken',
            component: QbExpenseFormComponent,
          },
          {
            path: 'accounting/quickbooks/payrolls',
            component: QbExpenseListComponent,
          },
          {
            path: 'accounting/quickbooks/payrolls/add',
            component: QbExpenseFormComponent,
          },
          {
            path: 'accounting/quickbooks/payrolls/edit/:id/:syncToken',
            component: QbExpenseFormComponent,
          },
          {
            path: 'accounting/quickbooks/vendors',
            component: QbVendorListComponent,
          },
          {
            path: 'accounting/quickbooks/vendors/add',
            component: QbVendorFormComponent,
          },
          {
            path: 'accounting/quickbooks/vendors/edit/:id/:syncToken',
            component: QbVendorFormComponent,
          },
        ],
      },
      // {
      //   path: 'finance',
      //   children: [
      //     {
      //       path: '',
      //       component: StripeComponent,
      //     },
      //     {
      //       path: 'plaid',
      //       component: PlaidComponent,
      //     },

      //     {
      //       path: 'paypal',
      //       component: PaypalComponent,
      //     },
      //     {
      //       path: 'helcim',
      //       component: HelcimComponent,
      //     },
      //     {
      //       path: 'square',
      //       component: SquareComponent,
      //     },
      //     {
      //       path: 'merchant',
      //       component: MerchantComponent,
      //     },
      //     {
      //       path: 'analysis',
      //       component: AnalysisComponent,
      //     },
      //   ],
      // },
      {
        path: 'billing',
        children: [
          /*  {
            path: 'invoices',
            component: InvoicesListComponent,
          }, */
          {
            path: 'invoices/add',
            component: InvoicesComponent,
          },
          {
            path: 'invoices/edit/:id',
            component: InvoicesComponent,
          },
          {
            path: 'invoices/contacts',
            component: ContactsListComponent,
          },
          {
            path: 'invoices/contacts/add',
            component: ContactsFormComponent,
          },
          {
            path: 'invoices/contacts/edit/:id',
            component: ContactsFormComponent,
          },
          {
            path: 'invoices/items',
            component: ItemsListComponent,
          },
          {
            path: 'invoices/items/add',
            component: ItemsFormComponent,
          },
          {
            path: 'invoices/items/edit/:id',
            component: ItemsFormComponent,
          },
        ],
      },
      {
        path: 'administracion',
        children: [
          {
            path: 'services',
            component: IndexServiciosComponent,
          },
          {
            path: 'services/create',
            component: FormServiciosComponent,
          },
          {
            path: '',
            component: UsersListComponent,
          },
          {
            path: 'users/add',
            component: UsersFormComponent,
          },
          {
            path: 'users/edit/:id',
            component: UsersFormComponent,
          },
          {
            path: 'users/editProfile/:id',
            component: EditProfileComponent,
          },
          {
            path: 'roles',
            component: RolesListComponent,
          },
          {
            path: 'roles/add',
            component: RolesFormComponent,
          },
          {
            path: 'roles/edit/:id',
            component: RolesFormComponent,
          },
          {
            path: 'configs',
            component: ConfigsListComponent,
          },
          {
            path: 'configs/add',
            component: ConfigsFormComponent,
          },
          {
            path: 'configs/edit/:id',
            component: ConfigsFormComponent,
          },
          {
            path: 'categories',
            component: CategoriesListComponent,
          },
          {
            path: 'categories/add',
            component: CategoriesFormComponent,
          },
          {
            path: 'categories/edit/:id',
            component: CategoriesFormComponent,
          },
        ],
      },
      // {
      //   path: 'drivers',
      //   children: [
      //     {
      //       path: '',
      //       component: DriverComponent,
      //     },
      //     {
      //       path: 'edit/:id',
      //       component: DriverFormComponent,
      //     },
      //   ],
      // },

      // {
      //   path: 'customers',
      //   children: [
      //     {
      //       path: '',
      //       component: CustomersListComponent,
      //     },
      //     {
      //       path: 'edit/:id',
      //       component: CustomersFormComponent,
      //     },
      //   ],
      // },
      // {
      //   path: 'accounting',
      //   children: [
      //     {
      //       path: '',
      //       component: PersonnelListComponent,
      //     },
      //     {
      //       path: 'external',
      //       component: AccountingComponent,
      //     },
      //     {
      //       path: 'external/add',
      //       component: AccountingFormComponent,
      //     },
      //     {
      //       path: 'external/edit/:id',
      //       component: AccountingFormComponent,
      //     },
      //     {
      //       path: 'personnel/add',
      //       component: PersonnelFormComponent,
      //     },
      //     {
      //       path: 'personnel/edit/:id',
      //       component: PersonnelFormComponent,
      //     },
      //     {
      //       path: 'freelancers',
      //       component: PersonnelListComponent,
      //     },
      //     {
      //       path: 'freelancers/edit/:id',
      //       component: PersonnelFormComponent,
      //     },
      //     {
      //       path: 'drivers',
      //       component: PersonnelListComponent,
      //     },
      //     {
      //       path: 'drivers/edit/:id',
      //       component: PersonnelFormComponent,
      //     },
      //     {
      //       path: 'customers',
      //       component: PersonnelListComponent,
      //     },
      //     {
      //       path: 'customers/edit/:id',
      //       component: PersonnelFormComponent,
      //     },
      //     {
      //       path: 'invoices',
      //       component: InvoicesListComponent,
      //     },
      //     {
      //       path: 'quickbooks/expenses',
      //       component: QbExpenseListComponent,
      //     },
      //     {
      //       path: 'quickbooks/expenses/add',
      //       component: QbExpenseFormComponent,
      //     },
      //     {
      //       path: 'quickbooks/expenses/edit/:id/:syncToken',
      //       component: QbExpenseFormComponent,
      //     },
      //     {
      //       path: 'quickbooks/payrolls',
      //       component: QbExpenseListComponent,
      //     },
      //     {
      //       path: 'quickbooks/payrolls/add',
      //       component: QbExpenseFormComponent,
      //     },
      //     {
      //       path: 'quickbooks/payrolls/edit/:id/:syncToken',
      //       component: QbExpenseFormComponent,
      //     },
      //     {
      //       path: 'quickbooks/vendors',
      //       component: QbVendorListComponent,
      //     },
      //     {
      //       path: 'quickbooks/vendors/add',
      //       component: QbVendorFormComponent,
      //     },
      //     {
      //       path: 'quickbooks/vendors/edit/:id/:syncToken',
      //       component: QbVendorFormComponent,
      //     },
      //   ],
      // },
      {
        path: 'hub',
        children: [
          {
            path: '',
            component: WpBotListComponent,
          },
          {
            path: 'wpbot/edit',
            component: WpBotFormComponent,
          },
          {
            path: 'chatbot',
            component: ChatBotListComponent,
          },
          {
            path: 'chatbot/edit',
            component: ChatBotFormComponent,
          },
        ],
      },
      {
        path: 'humanResources',
        children: [
          {
            path: '',
            component: HumanPersonnelListComponent,
          },
          {
            path: 'personnel/add',
            component: HumanPersonnelFormComponent,
          },
          {
            path: 'personnel/edit/:id',
            component: HumanPersonnelFormComponent,
          },
          {
            path: 'toolkit',
            component: ToolkitListComponent,
          },
          {
            path: 'freelancers',
            component: HumanPersonnelListComponent,
          },
          {
            path: 'freelancers/edit/:id',
            component: HumanPersonnelFormComponent,
          },
          {
            path: 'drivers',
            component: HumanPersonnelListComponent,
          },
          {
            path: 'customers',
            component: HumanPersonnelListComponent,
          },
        ],
      },
      {
        path: 'marketing',
        children: [
          /* {
            path: '',
            component: MarketingListComponent,
          }, */
          // {
          //   path: '',
          //   component: SeoOffPageCampaignsListComponent,
          // },
          {
            path: '',
            component: SeoOffPageCampaignsFormComponent,
          },
          {
            path: 'ads',
            component: AdsComponent,
          },
          {
            path: 'social',
            children: [
              {
                path: '',
                component: SocialComponent,
              },
              {
                path: 'contentRequests',
                component: SocialContentRequestListComponent,
              },
              {
                path: 'contentRequests/add',
                component: SocialContentRequestFormComponent,
              },
              {
                path: 'contentRequests/edit/:id',
                component: SocialContentRequestFormComponent,
              },
              {
                path: 'registry',
                component: SocialRegistryListComponent,
              },
              {
                path: 'registry/add',
                component: SocialRegistryFormComponent,
              },
              {
                path: 'registry/edit/:id',
                component: SocialRegistryFormComponent,
              },
              {
                path: 'strategy',
                component: StrategyComponent,
              },
              {
                path: 'semantika',
                component: SemantikaComponent,
              },
              {
                path: 'performance',
                component: PerformanceSocialComponent,
              },
              {
                path: 'requestIntake',
                component: RequestIntakeComponent,
              },
            ],
          },
          {
            path: 'seo',
            children: [
              {
                path: 'registry',
                component: SeoRegistryListComponent,
              },
              {
                path: 'registry/add',
                component: SeoRegistryFormComponent,
              },
              {
                path: 'registry/edit/:id',
                component: SeoRegistryFormComponent,
              },
              {
                path: 'qaRun',
                component: QaRunFormComponent,
              },
              {
                path: 'qaRun/view',
                component: QaRunListComponent,
              },
              {
                path: 'internalLinks',
                component: InternalLinksListComponent,
              },
              {
                path: 'internalLinks/add',
                component: InternalLinksComponent,
              },
              {
                path: 'offPageCampaigns/add',
                component: SeoOffPageCampaignsFormComponent,
              },
              {
                path: 'offPageCampaigns/edit/:id',
                component: SeoOffPageCampaignsFormComponent,
              },
              {
                path: 'offPageCampaigns/view/:id',
                component: SeoOffPageCampaignsFormComponent,
              },
              {
                path: 'offPageCampaigns/reviews/:id',
                component: SeoOffPageCampaignsReviewsComponent,
              },
              {
                path: 'offPageCampaigns/urlMapping',
                component: UrlMappingComponent,
              },
              {
                path: 'onPage',
                component: OnPageComponent,
              },
              {
                path: 'technicalQa',
                component: TechnicalQaComponent,
              },
              {
                path: 'localSeo',
                component: LocalSeoComponent,
              },
              {
                path: 'offPage',
                component: OffPageComponent,
              },
              {
                path: 'performance',
                component: PerformanceComponent,
              },
              {
                path: 'offPageRecommendations',
                component: SeoOffPageRecommendationsListComponent,
              },
              {
                path: 'offPageRecommendations/view/:id',
                component: SeoOffPageRecommendationsFormComponent,
              },
              {
                path: 'offPageProspects',
                component: SeoOffPageProspectsListComponent,
              },
              {
                path: 'offPageProspects/add',
                component: SeoOffPageProspectsFormComponent,
              },
              {
                path: 'offPageProspects/edit/:id',
                component: SeoOffPageProspectsFormComponent,
              },
              {
                path: 'offPageProspects/view/:id',
                component: SeoOffPageProspectsFormComponent,
              },
              {
                path: 'offPageBacklinks',
                component: SeoOffPageBacklinksListComponent,
              },
              {
                path: 'offPageBacklinks/view/:id',
                component: SeoOffPageBacklinksFormComponent,
              },
              {
                path: 'offPageDashboard',
                component: SeoOffPageDashboardComponent,
              },
            ],
          },
          {
            path: 'mediaroom',
            children: [
              {
                path: '',
                component: MediaroomComponent,
              },
              {
                path: 'social',
                component: MroomsocialComponent,
              },
            ],
          },
          {
            path: 'mediaroomRegistry',
            component: MediaRoomRegistryListComponent,
          },
          {
            path: 'mediaroomRegistry/add',
            component: MediaRoomRegistryFormComponent,
          },
          {
            path: 'mediaroomRegistry/edit/:id',
            component: MediaRoomRegistryFormComponent,
          },
          {
            path: 'registry',
            children: [
              {
                path: '',
                component: RegistryComponent,
              },
            ],
          },
        ],
      },

      {
        path: 'companyInfo',
        children: [
          {
            path: '',
            component: CompanyListComponent,
          },
        ],
      },
      {
        path: 'documents',
        children: [
          {
            path: '',
            component: DocsListComponent,
          },
          {
            path: 'add',
            component: DocsFormComponent,
          },
        ],
      },
      {
        path: 'observability',
        children: [
          /* {
            path: '',
            component: ObsMarketingComponent,
          }, */
          {
            path: '',
            component: SeoMetricsDailyListComponent,
          },
          {
            path: 'ads',
            component: ObsAdsComponent,
          },
          {
            path: 'social',
            component: ObsSocialComponent,
          },
          {
            path: 'social/audits',
            component: ObsSocialAuditComponent,
          },
          {
            path: 'social/executive',
            component: ObsSocialExecutiveComponent,
          },
          {
            path: 'social/leads',
            component: ObsSocialLeadsComponent,
          },
          {
            path: 'mediaroom',
            component: ObsMediaroomComponent,
          },
          {
            path: 'logistics',
            component: ObsLogisticsComponent,
          },
          {
            path: 'accounting',
            component: ObsAccountingComponent,
          },
          {
            path: 'finance',
            component: ObsFinanceComponent,
          },
          {
            path: 'hr',
            component: ObsHrComponent,
          },
          {
            path: 'seo/metricsDaily',
            component: SeoMetricsDailyListComponent,
          },
          {
            path: 'seo/actionsBacklog',
            component: SeoActionsBacklogListComponent,
          },
          {
            path: 'seo/metricsWeekly',
            component: SeoMetricsWeeklyListComponent,
          },
          {
            path: 'seo/cannibalClusters',
            component: SeoCannibalClusterListComponent,
          },
          {
            path: 'seo/cannibalClusters/:id',
            component: SeoCannibalClusterFormComponent,
          },
          {
            path: 'seo/cannibalEdges',
            component: SeoCannibalEdgeListComponent,
          },
          {
            path: 'seo/localSeo/locations',
            component: GbpLocationsListComponent,
          },
          {
            path: 'seo/localSeo/reviews',
            component: GbpReviewsInboxComponent,
          },
          {
            path: 'seo/localSeo/actions',
            component: LocalActionsQueueComponent,
          },
          {
            path: 'seo/technicalAudits',
            component: TechnicalAuditsPageComponent,
          },
          {
            path: 'seo/sitemapAudits',
            component: SitemapAuditsPageComponent,
          },
          {
            path: 'seo/offPagePerformance',
            component: OffPagePerformanceListComponent,
          },
          {
            path: 'seo/offPagePerformance/:campaignId',
            component: OffPagePerformanceDetailComponent,
          },
          {
            path: 'seo/keywordInsights',
            component: SeoKeywordInsightListComponent,
          },
          {
            path: 'seo/keywordInsights/:id',
            component: SeoKeywordInsightDetailComponent,
          },
        ],
      },
      {
        path: 'logistics',
        children: [
          {
            path: '',
            component: DriverComponent,
          },
          {
            path: 'drivers/edit/:id',
            component: DriverFormComponent,
          },
          {
            path: 'customers',
            component: CustomersListComponent,
          },
          {
            path: 'customers/edit/:id',
            component: CustomersFormComponent,
          },
          /* {
            path: '',
            component: LogisticsListComponent,
          }, */
          {
            path: 'fees',
            component: CourierChargesListComponent,
          },
          {
            path: 'fees/courier/add',
            component: CourierChargesFormComponent,
          },
          {
            path: 'fees/courier/edit/:id',
            component: CourierChargesFormComponent,
          },
          {
            path: 'fees/surcharges',
            component: IndexSurchargesComponent,
          },
          {
            path: 'fees/surcharges/create',
            component: FormSurchargesComponent,
          },
          {
            path: 'fees/surcharges/edit/:id',
            component: FormSurchargesComponent,
          },
          {
            path: 'fees/task',
            component: TaskChargesListComponent,
          },
          {
            path: 'fees/task/add',
            component: TaskChargesFormComponent,
          },
          {
            path: 'fees/task/edit/:id',
            component: TaskChargesFormComponent,
          },
          {
            path: 'fees/volume',
            component: VolumeChargesListComponent,
          },
          {
            path: 'fees/volume/add',
            component: VolumeChargesFormComponent,
          },
          {
            path: 'fees/volume/edit/:id',
            component: VolumeChargesFormComponent,
          },
          {
            path: 'fees/weight',
            component: WeightChargesListComponent,
          },
          {
            path: 'fees/weight/add',
            component: WeightChargesFormComponent,
          },
          {
            path: 'fees/weight/edit/:id',
            component: WeightChargesFormComponent,
          },
          {
            path: 'fees/driverCourier',
            component: DriverCourierListComponent,
          },
          {
            path: 'fees/driverCourier/add',
            component: DriverCourierFormComponent,
          },
          {
            path: 'fees/driverCourier/edit/:id',
            component: DriverCourierFormComponent,
          },
          {
            path: 'fees/driverTask',
            component: DriverTaskListComponent,
          },
          {
            path: 'fees/driverTask/add',
            component: DriverTaskFormComponent,
          },
          {
            path: 'fees/driverTask/edit/:id',
            component: DriverTaskFormComponent,
          },
          {
            path: 'fees/driverVolume',
            component: DriverVolumeListComponent,
          },
          {
            path: 'fees/driverVolume/add',
            component: DriverVolumeFormComponent,
          },
          {
            path: 'fees/driverVolume/edit/:id',
            component: DriverVolumeFormComponent,
          },
          {
            path: 'fees/driverWeight',
            component: DriverWeightListComponent,
          },
          {
            path: 'fees/driverWeight/add',
            component: DriverWeightFormComponent,
          },
          {
            path: 'fees/driverWeight/edit/:id',
            component: DriverWeightFormComponent,
          },
          {
            path: 'fees/emm',
            component: EmmChargesListComponent,
          },
          {
            path: 'fees/emm/add',
            component: EmmChargesFormComponent,
          },
          {
            path: 'fees/emm/edit/:id',
            component: EmmChargesFormComponent,
          },
          {
            path: 'fees/driverEmm',
            component: DriverEmmListComponent,
          },
          {
            path: 'fees/driverEmm/add',
            component: DriverEmmFormComponent,
          },
          {
            path: 'fees/driverEmm/edit/:id',
            component: DriverEmmFormComponent,
          },
        ],
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'pages',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'visitor',
    component: VisitorComponent,
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent,
  },
];
